var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimesRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85714 1L15 14.1429L14.1429 15L1 1.85714L1.85714 1Z",
    fill: "#EF382A",
    stroke: "#EF382A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1429 1L1 14.1429L1.85714 15L15 1.85714L14.1429 1Z",
    fill: "#EF382A",
    stroke: "#EF382A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimesRed);
export default __webpack_public_path__ + "static/media/icon-times-red.d56a142c.svg";
export { ForwardRef as ReactComponent };